import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { actionType } from 'utils/constants';

import utils from 'utils';
import actions from 'state/actions';

import CommonButton from 'components/Buttons/CommonButton';
import selectors from 'state/selectors';
import services from 'services';
import axios from 'axios';

const Edit = () => {
  const dispatch = useDispatch();
  const t = utils.intl.useTranslator();
  const selectedRowId = useSelector(selectors.configurator.getSelectedRowId);
  const selectedRow = useSelector(selectors.configurator.getSelectedRow);
  const editRowId = useSelector(selectors.configurator.getEditedRowId);
  const selectedCompanies = useSelector(selectors.configurator.getSelectedCompanies);

  const editRow = async () => {
    try {
      if (selectedRow == null) throw new Error('No row selected');
      const { data: casuals } = await services.getWfCasuals(selectedRow.idCompany);
      const { data: definitions } = await services.getWfDefinitions(selectedRow.idCompany);
      dispatch(actions.configurator.setWfCasuals(casuals));
      dispatch(actions.configurator.setWfDefinitions(definitions));
      dispatch(actions.configurator.setEditedRowId(selectedRowId));
      dispatch(actions.configurator.setNotModifiedRow(selectedRow));
    } catch (error) {
      if (axios.isAxiosError(error)) {
        utils.app.notify('fail', error.response?.data.message);
        console.error(error.response?.data.message);
        return;
      }
      console.error(error);
    }
  };
  return (
    <CommonButton
      id="edit-row-action-table"
      action={async () => await editRow()}
      scope="tertiary"
      value={t('editActionTable')}
      customIcon="pen"
      disabled={
        selectedCompanies.length === 0 ||
        !selectedRowId ||
        editRowId !== undefined ||
        !utils.user.isActionByCompanyActive(actionType.ACTION_TABLE_EDIT_ROW, selectedRow?.companyName)
      }
    />
  );
};

export default Edit;
